export const profile = {
  name: "Alok Kumar",
  title: "Cloud Architect & Software Engineer",
  tagline: "Architecting Resilient Cloud Infrastructure & Scalable Full-Stack Solutions",
  email: "alokkumarkaranraj@gmail.com",
  github: "Alokkumarkaran",
  linkedin: "https://www.linkedin.com/in/alok-kumar-karan//"
}
